export default function dropdownTouchFix () {
    const dropdown = document.querySelector(".nav-item.dropdown");
    if (!dropdown) return;
    
    const toggle = dropdown.querySelector(".dropdown-toggle");
    if (!toggle) return;

    let tappedOnce = false;

    toggle.addEventListener("click", function (e) {
        // Only apply custom behavior on mobile/tablet
        if (window.innerWidth < 992) {
            if (!tappedOnce) {
                e.preventDefault();
                dropdown.classList.add("show");
                dropdown.querySelector(".dropdown-menu").classList.add("show");
                tappedOnce = true;

                document.addEventListener("click", function resetTap (ev) {
                    if (!dropdown.contains(ev.target)) {
                        dropdown.classList.remove("show");
                        dropdown.querySelector(".dropdown-menu").classList.remove("show");
                        tappedOnce = false;
                        document.removeEventListener("click", resetTap);
                    }
                });
            }
        }
        // On desktop, let Bootstrap handle it
    });
}